import { $ } from "@/common/Axios";

export default {
  /**
   * 学生通知
   */
  studentNotice_confirm: {
    /*
     * 确认（填写字段并完成）
     * id id (integer query required)
     * infoColumns 信息字段 (string query )
     */
    put: (p, c) => $.put("/api/bms/notice/studentNotice/confirm", p, c),
  },
  studentNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/list", p, c),
  },
  studentNotice_export: {
    /*
     * 导出
     * educateNoticeId 教务通知ID (integer query )
     * serviceNoticeId 服务通知ID (integer query )
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/export", p, c),
  },
  studentNotice_details: {
    /*
     * 详情
     * id 学生通知ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/details", p, c),
  },
  studentNotice_detailsByService: {
    /*
     * 根据服务通知ID和身份证号获取详情
     * serviceNoticeId 服务通知ID (integer query required)
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/notice/studentNotice/detailsByService", p, c),
  },

  /**
   * 服务通知
   */
  serviceNotice_finish: {
    /*
     * 完成
     * noticeId 通知id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/serviceNotice/finish", p, c),
  },
  serviceNotice_uploadStudent: {
    /*
     * 上传学生列表
     * noticeId 通知id (integer query required)
     * type 类型：覆盖、新增 (string query required)
     * studentIds 学生id（合同编号） (array query required)
     */
    post: (p, c) => $.post("/api/bms/notice/serviceNotice/uploadStudent", p, c),
  },
  serviceNotice_send: {
    /*
     * 确认名单生成学生通知
     * noticeId 通知id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/notice/serviceNotice/send", p, c),
  },
  serviceNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/list", p, c),
  },
  serviceNotice_listStudent: {
    /*
     * 获取学生列表
     * noticeId 通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/listStudent", p, c),
  },
  serviceNotice_listFinishInfo: {
    /*
     * 获取通知完成情况
     * educateNoticeId 教务通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/listFinishInfo", p, c),
  },
  serviceNotice_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/details", p, c),
  },

  /**
   * 通知模板
   */
  noticeTmpl_setInfoColumns: {
    /*
     * 设置信息字段
     * id id (integer query required)
     * infoColumns 信息字段 (string query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/setInfoColumns", p, c),
  },
  noticeTmpl_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/publish", p, c),
  },
  noticeTmpl_abandon: {
    /*
     * 废弃
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/abandon", p, c),
  },
  noticeTmpl: {
    /*
     * 添加
     * tmpl  ( query required)
     */
    post: (p, c) => $.post("/api/bms/notice/noticeTmpl", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/notice/noticeTmpl", p, c),
  },
  noticeTmpl_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/list", p, c),
  },
  noticeTmpl_listSimple: {
    /*
     * 简易列表
     * statuses 状态 (array query )
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/listSimple", p, c),
  },
  noticeTmpl_listAvailable: {
    /*
     * 可用变量列表
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/listAvailable", p, c),
  },
  noticeTmpl_getInfoColumns: {
    /*
     * 获取信息字段
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/getInfoColumns", p, c),
  },

  /**
   * 教务通知
   */
  educateNotice_refreshFinishStatus: {
    /*
     * 刷新完成状态（根据模板完成条件重新判断）
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/notice/educateNotice/refreshFinishStatus", p, c),
  },
  educateNotice_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/publish", p, c),
  },
  educateNotice_finish: {
    /*
     * 完结
     * id id (integer query required)
     * finishStatus 完结状态 (string query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/finish", p, c),
  },
  educateNotice: {
    /*
     * 添加
     * notice  ( query required)
     */
    post: (p, c) => $.post("/api/bms/notice/educateNotice", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/notice/educateNotice", p, c),
  },
  educateNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/list", p, c),
  },
  educateNotice_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/details", p, c),
  },
};
